import React from 'react'

import cls from './Auth.module.scss'

const Auth = ({ children, style }) => {
  return (
    <div className={cls.pageWrapper} style={style}>
      {children}
    </div>
  )
}

export default Auth
